module.exports = __webpack_public_path__ + "static/media/contact-banner.dc37a61c.svg";